<template>
  <div class="screen" id="workspace-selection-screen">
    <transition name="fadeLogin" mode="out-in" appear>
      <div class="workspace-selection-container">
        <workspace-selection-header />

        <div class="workspace-selection-content-container">
          <div
            class="workspace-selection"
            style="position: relative; overflow: auto"
          >
            <workspaces-list
              :search-from-parent="workspaceSearch"
              @update-search="workspaceSearch = $event"
            />
          </div>
        </div>
      </div>
    </transition>


  </div>
</template>

<script>
import WorkspacesList from "../components/Workspaces/WorkspacesList";
import WorkspaceSelectionHeader from "@/components/Workspaces/Header";

export default {
  name: "WorkspaceSelection",

  components: {
    WorkspaceSelectionHeader,
    WorkspacesList
  },

  data() {
    return {
      /**
       * Save the value of the last search
       */
      workspaceSearch: ""
    };
  }
};
</script>

<style scoped>
::-webkit-scrollbar-track {
  background: transparent;
}

#workspace-selection-screen {
  background-color: #ffffff;
}

.workspace-selection-container {
  height: 100%;
  width: 100%;
  position: relative;
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.3);
}

.workspace-selection-content-container {
  width: 100%;
  height: calc(100% - 78px);
  padding: 20px 100px;
}

.workspace-selection {
  width: 100%;
  height: calc(100% - 48px);
  display: flex;
  padding: 40px 30px 30px;
}

/**
 * Slot inputs
 * remove bottom border
 
.text-field.v-text-field > .v-input__control > .v-input__slot:before,
.text-field.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}
*/
</style>



// WEBPACK FOOTER //
// src/views/Workspaces.vue